<div class="main-container input" [ngClass]="{'disabled-input': readonly, 'invalid-input': invalidInput }">
  <div class="prefix d-flex justify-content-center align-items-center">
    <p class="mb-0 prefix-text">{{ prefix }}</p>
  </div>

  <input
    appNumbersOnly
    [readonly]="readonly"
    [placeholder]="placeHolder"
    (input)="onInputChange($event)"
    [(ngModel)]="value.inputValue"
  />

  <select name="" id="" class="dropdown-input" (change)="onDropdownChange($event)" [(ngModel)]="value.dropdownValue" [disabled]="disableDrowdown || readonly">
    <option [value]="null" hidden>NA</option>
    <option *ngFor="let item of dropdownArray" [value]="item.value">{{ item.name }}</option>
  </select>
</div>
